<template>
  <div class="wholeContext">
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <div class="join container">
        <div class="notification">
          <span class="imgWrap"><img src="../../assets/images/thanq_logo.png" /></span>
          <p>비밀번호 변경이 완료 되었어요!</p>
          <p>땡큐와 함께 쉽고 편리하게 건강을 관리하세요!</p>
        </div>
      </div>
      <div class="btnWrap visible">
        <button class="" type="button" @click="nextMain()">메인페이지</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      transDate: {
        headerName: '비밀번호변경 완료',
        prevUrl: '/'
      },
      setCount: false,
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false
    }
  },
  components: {
    AppHeader
  },
  methods: {
    ...mapMutations([
    ]),
    nextMain () {
      this.$router.push('/')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
